import React, {
  useMemo,
  useRef,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { SwapHoriz, Create } from '@material-ui/icons';
import { isArray } from 'lodash';

import api from '~/services/api';
import { Modal, Table, UnidataTable } from '~/components';
import { t, number, canURL } from '~/helpers';
import { recordFiltering } from '~/store/modules/unidadeSaldoCota/actions';

import { Transferencia, Alteration } from './components';

import * as S from './styles';

export default function UnidadeSaldoCota() {
  const data = useSelector((state) => state.unidadeSaldoCota);
  const { orga_codigo, perf_tipo } = useSelector(
    (state) => state.user.usuarioacesso
  );
  const permission = canURL();

  const transferRef = useRef(null);
  const alterRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [quotations, setQuotations] = useState([]);
  const [active, setActive] = useState({});

  const status = useMemo(
    () => [
      { value: 'Ativa', label: 'A' },
      { value: 'Inativa', label: 'I' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'orga_nome',
        label: 'Nome do Órgão',
        filter: { type: 'text' },
      },
      {
        id: 'unid_codigo',
        label: 'Código',
        filter: { type: 'text' },
      },
      {
        id: 'unid_nome',
        label: 'Nome da Unidade',
        filter: { type: 'text' },
      },
      {
        id: 'unid_status',
        label: 'Status',
        align: 'center',
        formatted: (value) => status.find((s) => s.label === value).value,
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  const headerTable = useMemo(
    () => [
      { id: 'prod_codigo', label: 'Cód. Produto', align: 'center' },
      { id: 'prod_descricao', label: 'Nome Produto' },
      { id: 'coor_saldo', label: 'Saldo', format: (value) => number(value, 1), align: 'right' },
    ],
    []
  );

  const headerDetais = useMemo(
    () => [
      { id: 'prod_descricao', label: 'Cód. Produto', align: 'center' },
      { id: 'prod_descricao', label: 'Nome Produto' },
      { id: 'coun_saldo', label: 'Saldo', format: (value) => number(value, 1), align: 'right' },
    ],
    []
  );

  const handleGetAPIUnity = useCallback(async (id, organ) => {
    try {
      await api.get(`unidades/pesquisaunidade/${id}/${organ}`).then(({ data }) => {        
        transferRef.current.handleOpenModal({ 
          data: data//data.unidade,
          //cotas: data.cotas 
        })        
      });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data.params]);



  const buttons = useMemo(() => {
    if (!permission.update) return [];

    if (perf_tipo === 3) {
      return [
        {
          title: 'Alterar',
          action: (value) => alterRef.current.handleOpenModal({ data: value }),
          icon: <Create />,
        },
      ];
    }

    return [
      {
        title: 'Transferência',
        action: (value) =>
          handleGetAPIUnity(value.unid_codigo, value.orga_codigo),        
        icon: <SwapHoriz />,
      },
    ];
   
    /*return [
      {
        title: 'Transferência',
        action: (value) => transferRef.current.handleOpenModal({ data: value }),
        icon: <SwapHoriz />,
      },
    ];
    */

  }, [perf_tipo, permission.update]);

  const actionsModal = useMemo(
    () => [
      {
        label: t('s.geral.botaofechar'),
        callback: () => alterRef.current.handleCloseModal(),
        color: 'secondary',
      },
    ],
    []
  );

  const handleGetProducts = useCallback(
    async ({ orga_codigo, unid_codigo }) => {
      try {
        if (orga_codigo && unid_codigo) {
          setLoading(true);
          setActive({ orga_codigo, unid_codigo });

          const response = await api.get(
            `cotaunidade/${unid_codigo}/${orga_codigo}`
          );

          setDetails(response.data);
        }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const handleGetQuotation = useCallback(async () => {
    try {
      setLoading(true);

      const response = await api.get(`orgaocotasaldo/total/${orga_codigo}`);
      setQuotations(response.data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [orga_codigo]);

  const handleSaldoCotaClose = useCallback((value) => {
    handleGetProducts(value.data)
    handleGetQuotation()
  }, [])

  useEffect(() => {
    handleGetQuotation();
  }, []);

  return (
    <S.Wrapper>
      {perf_tipo === 3 && (
        <Table
          title="Informações do Saldo do Órgão"
          cells={headerTable}
          data={quotations}
          size="small"
          showPagination={false}
          maxHeight="8vh"
        />
      )}

      <UnidataTable
        dense
        fixed
        header={header}
        read={recordFiltering}
        redux={data}
        actions={buttons}
        create={false}
        update={false}
        delete={false}
        onRow={handleGetProducts}
        keys={['unid_codigo', 'orga_codigo']}
        detach="unidadeSaldoCota"
        maxHeight="40vh"
      />

      <Table
        loading={loading}
        cells={headerDetais}
        data={details}
        size="small"
        showPagination={false}
      />

      <Modal
        ref={transferRef}
        form
        disableBackdropClick
        disableEscapeKeyDown
        component={Transferencia}
        title="Transferência Saldo/Cota Entre Unidades"
        loading={loading}
        maxWidth="sm"
        onClose={() => handleGetProducts(active)}
      />

      <Modal
        ref={alterRef}
        disableBackdropClick
        disableEscapeKeyDown
        component={Alteration}
        title="Saldo/Cota"
        loading={loading}
        onClose={(value) => handleSaldoCotaClose(value)}
        actions={actionsModal}
      />
    </S.Wrapper>
  );
}
